import { Navigate, Outlet, useLocation } from 'react-router-dom';

const PrivateRoutes = () => {
  const location = useLocation();
  let token = localStorage.getItem('accessToken') ? true : false;
  return token ? (
    <Outlet />
  ) : (
    <Navigate to="/login" replace state={{ redirectTo: location }} />
  );
};

export default PrivateRoutes;
